import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import msg from 'sweetalert2';        
import { AuthService } from 'src/app/services/auth.service';
import * as moment from 'moment';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {
  
  loading: boolean= false;
  
  itm={
    id:0,
    id_matriz:1,
    nombre:"",
    numero:"",
    objetivo:"",
    facilitador:"",
    patrocinador:"",
    vpmexico:"",
  }
  fechaini;
  fechaestini;
  fechaestfin;

  fechapat;
  fechavp;

  
  bRegistro: boolean=false;

  
  ant = []
  txtant = "";
  est = []
  txtest = "";
  ent = []
  txtent = "";

  int;
  lstint = []
  selint;

  equ;
  lstequ = []
  selequ;

  mat = []
  txtmat = "";

  cap = []
  txtcap = "";

  lst;

  constructor(
    public authService: AuthService,
    public router: Router
  ) { }

  id_charter=0;
  ngOnInit() {
    this.bRegistro = true;
    
    var id=localStorage.getItem("id_charter");
    this.ls_charter(id);
  }

  fmt_assesment(){
    localStorage.setItem("tpo","X")
    this.router.navigate([]).then(result => {  window.open('./fmtcharter', '_blank'); });          
  }
  ls_charter(id){
    this.loading = true;          
    var sqry;
    sqry = " select" +
           " id, id_matriz, nombre, numero, objetivo, facilitador, patrocinador, vpmexico, fechaini," +
           " fechaestini,fechaestfin,fechapat,fechavp" +
           " from tblcharter_cha" +
           " where id_matriz = " +id +
           " order by nombre";
    this.loading =  true;
    //console.log(sqry)
    this.authService.ejecuta1(sqry)
    .then(
      data  => {    
       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);    
        if (res.length!=0){
          this.nvocha(res[0].id,data[0])
        }else{
          this.nvocha(0,null)
        }            
    },
    error => {
        this.loading =  false;
        msg.fire('Datos incorrectos', '', 'error');
    });
  }


  ls_integrantes(){    
    this.loading = true;          
    var sqry;
    sqry = " select" +
           " tblpersona_tl.id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo" +
           " from tblpersona_tl" +
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
           " where tblpersona_tl.id_cliente="+localStorage.getItem("id_cliente")+
           " order by nombre";
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                        
        this.int = data;
    },
    error => {
        this.loading =  false;
        msg.fire('Datos incorrectos', '', 'error');
    });
  }

  ls_equipo(){    
    this.loading = true;          
    var sqry;
 
           sqry = " select" +
           " tblpersona_tl.id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo as job" +
           " from tblpersona_tl" +
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
           " where tblpersona_tl.id_cliente="+localStorage.getItem("id_cliente")+
           " order by nombre";
    this.loading =  true;

    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;                        
        this.equ = data;
    },
    error => {
        this.loading =  false;
        msg.fire('Datos incorrectos', '', 'error');
    });
  }
  
  nvoant(){
    if (this.txtant == ""){
      msg.fire("Proporcine el antecedente","","warning");
      return;
    }
    this.ant.push({ 
      id:  0, 
      idx: this.ant.length+1,
      nombre: this.txtant,      
      nombre1: this.txtant,      
      edita: false
    });
    this.txtant = "";
  }
  ediant(itm){    
    for (let i = 0; i < this.ant.length; i++) {
      this.ant[i].edita = false;
    }
    this.ant[itm.idx-1].edita = true;
  }
  canant(itm){
    this.ant[itm.idx-1].nombre1 = this.ant[itm.idx-1].nombre;
    this.ant[itm.idx-1].edita = false;
  }
  guaant(itm){
    if (this.ant[itm.idx-1].nombre1 == ""){
      msg.fire("Proporcine el antecedente","","warning");
      return;
    }
    this.ant[itm.idx-1].nombre = this.ant[itm.idx-1].nombre1;
    this.ant[itm.idx-1].edita = false;
  }
  eliant(itm){
    var objIndex = this.ant.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.ant.splice(objIndex, 1) 
    for (let i = 0; i < this.ant.length; i++) {
      this.ant[i].idx = i+1;
    }
  }

  nvoest(){
    if (this.txtest == ""){
      msg.fire("Proporcine la estrategia","","warning");
      return;
    }
    this.est.push({ 
      id:  0, 
      idx: this.est.length+1,
      nombre: this.txtest,      
      nombre1: this.txtest,      
      edita: false
    });
    this.txtest = "";
  }
  ediest(itm){
    for (let i = 0; i < this.est.length; i++) {
      this.est[i].edita = false;
    }
    this.est[itm.idx-1].edita = true;
  }
  canest(itm){
    this.est[itm.idx-1].nombre1 = this.est[itm.idx-1].nombre;
    this.est[itm.idx-1].edita = false;
  }
  guaest(itm){
    if (this.est[itm.idx-1].nombre1 == ""){
      msg.fire("Proporcine la estrategia","","warning");
      return;
    }
    this.est[itm.idx-1].nombre = this.est[itm.idx-1].nombre1;
    this.est[itm.idx-1].edita = false;
  }
  eliest(itm){
    var objIndex = this.est.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.est.splice(objIndex, 1) 
    for (let i = 0; i < this.est.length; i++) {
      this.est[i].idx = i+1;
    }
  }

  nvoent(){
    if (this.txtent == ""){
      msg.fire("Proporcine el entregable","","warning");
      return;
    }
    this.ent.push({ 
      id:  0, 
      idx: this.ent.length+1,
      nombre: this.txtent,      
      nombre1: this.txtent,      
      edita: false
    });
    this.txtent = "";
  }
  edient(itm){
    for (let i = 0; i < this.ent.length; i++) {
      this.ent[i].edita = false;
    }
    this.ent[itm.idx-1].edita = true;
  }
  canent(itm){
    this.ent[itm.idx-1].nombre1 = this.ent[itm.idx-1].nombre;
    this.ent[itm.idx-1].edita = false;
  }
  guaent(itm){
    if (this.ent[itm.idx-1].nombre1 == ""){
      msg.fire("Proporcine el entregable","","warning");
      return;
    }
    this.ent[itm.idx-1].nombre = this.ent[itm.idx-1].nombre1;
    this.ent[itm.idx-1].edita = false;
  }
  elient(itm){
    var objIndex = this.ent.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.ent.splice(objIndex, 1) 
    for (let i = 0; i < this.ent.length; i++) {
      this.ent[i].idx = i+1;
    }
  }

  nvoint(){
    if (this.selint == undefined){
      msg.fire("Seleccione el integrante","","warning");
      return;
    }
    this.lstint.push({ 
      id:  this.selint.id, 
      idx: this.lstint.length+1,
      nombre: this.selint.nombre,      
      nombre1: this.selint.nombre,      
      titulo: this.selint.titulo,      
      edita: false
    });    
    this.selint = null;
    this.selint = undefined;
  }
  ediint(itm){
    for (let i = 0; i < this.lstint.length; i++) {
      this.lstint[i].edita = false;
    }
    this.lstint[itm.idx-1].edita = true;    
  }
  canint(itm){    
    this.selint = null;
    this.selint = undefined;
    this.lstint[itm.idx-1].edita = false;
  }
  guaint(itm){
    if (this.selint == undefined){
      msg.fire("Seleccione el integrante","","warning");
      return;
    }
    this.lstint[itm.idx-1].id = this.selint.id;
    this.lstint[itm.idx-1].nombre = this.selint.nombre;
    this.lstint[itm.idx-1].nombre1 = this.selint.nombre;
    this.lstint[itm.idx-1].titulo = this.selint.titulo;
    this.lstint[itm.idx-1].edita = false;
    this.selint = null;
    this.selint = undefined;
  }
  eliint(itm){
    var objIndex = this.lstint.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.lstint.splice(objIndex, 1) 
    for (let i = 0; i < this.lstint.length; i++) {
      this.lstint[i].idx = i+1;
    }
  }

  //Equipo de soporte
  nvoequ(){
    if (this.selequ == undefined){
      msg.fire("Seleccione el equipo","","warning");
      return;
    }
    this.lstequ.push({ 
      id:  this.selequ.id, 
      idx: this.lstequ.length+1,
      nombre: this.selequ.nombre,      
      nombre1: this.selequ.nombre,      
      job: this.selequ.job,      
      edita: false
    });    
    this.selequ = null;
    this.selequ = undefined;
  }
  ediequ(itm){
    for (let i = 0; i < this.lstequ.length; i++) {
      this.lstequ[i].edita = false;
    }
    this.lstequ[itm.idx-1].edita = true;    
  }
  canequ(itm){    
    this.selequ = null;
    this.selequ = undefined;
    this.lstequ[itm.idx-1].edita = false;
  }
  guaequ(itm){
    if (this.selequ == undefined){
      msg.fire("Seleccione el equipo","","warning");
      return;
    }
    this.lstequ[itm.idx-1].id = this.selequ.id;
    this.lstequ[itm.idx-1].nombre = this.selequ.nombre;
    this.lstequ[itm.idx-1].nombre1 = this.selequ.nombre;
    this.lstequ[itm.idx-1].job = this.selequ.job;
    this.lstequ[itm.idx-1].edita = false;
    this.selequ = null;
    this.selequ = undefined;
  }
  eliequ(itm){
    var objIndex = this.lstequ.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.lstequ.splice(objIndex, 1) 
    for (let i = 0; i < this.lstequ.length; i++) {
      this.lstequ[i].idx = i+1;
    }
  }


  //Materiales
  nvomat(){
    if (this.txtmat == ""){
      msg.fire("Proporcine el material","","warning");
      return;
    }
    this.mat.push({ 
      id:  0, 
      idx: this.mat.length+1,
      nombre: this.txtmat,      
      nombre1: this.txtmat,      
      edita: false
    });
    this.txtmat = "";
  }
  edimat(itm){
    for (let i = 0; i < this.mat.length; i++) {
      this.mat[i].edita = false;
    }
    this.mat[itm.idx-1].edita = true;
  }
  canmat(itm){
    this.mat[itm.idx-1].nombre1 = this.mat[itm.idx-1].nombre;
    this.mat[itm.idx-1].edita = false;
  }
  guamat(itm){
    if (this.mat[itm.idx-1].nombre1 == ""){
      msg.fire("Proporcine el material","","warning");
      return;
    }
    this.mat[itm.idx-1].nombre = this.mat[itm.idx-1].nombre1;
    this.mat[itm.idx-1].edita = false;
  }
  elimat(itm){
    var objIndex = this.mat.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.mat.splice(objIndex, 1) 
    for (let i = 0; i < this.mat.length; i++) {
      this.mat[i].idx = i+1;
    }
  }

  //Entrenamiento
  nvocap(){
    if (this.txtcap == ""){
      msg.fire("Proporcine el entrenamiento","","warning");
      return;
    }
    this.cap.push({ 
      id:  0, 
      idx: this.cap.length+1,
      nombre: this.txtcap,      
      nombre1: this.txtcap,      
      edita: false
    });
    this.txtcap = "";
  }
  edicap(itm){
    for (let i = 0; i < this.cap.length; i++) {
      this.cap[i].edita = false;
    }
    this.cap[itm.idx-1].edita = true;
  }
  cancap(itm){
    this.cap[itm.idx-1].nombre1 = this.cap[itm.idx-1].nombre;
    this.cap[itm.idx-1].edita = false;
  }
  guacap(itm){
    if (this.cap[itm.idx-1].nombre1 == ""){
      msg.fire("Proporcine el entrenamiento","","warning");
      return;
    }
    this.cap[itm.idx-1].nombre = this.cap[itm.idx-1].nombre1;
    this.cap[itm.idx-1].edita = false;
  }
  elicap(itm){
    var objIndex = this.cap.findIndex(((itm1 :any) => itm1.idx == itm.idx));    
    this.cap.splice(objIndex, 1) 
    for (let i = 0; i < this.cap.length; i++) {
      this.cap[i].idx = i+1;
    }
  }

  cancelar(){
    this.router.navigate(['/hk']);
  }
  
  guardar(){
    if (this.itm.nombre == ""){    
      msg.fire('Proporcione el titulo del proyecto', '', 'warning');
      return;
    }
    if (this.itm.numero == ""){    
      msg.fire('Proporcione el número del proyecto', '', 'warning');
      return;
    }
    if (this.fechaini == ""){
      msg.fire('Proporcione la fecha de inicio', '', 'warning');
      return;
    }
    if (this.ant.length == 0){
      msg.fire('Proporcione por lo menos un antecedente', '', 'warning');
      return;
    }
    if (this.itm.objetivo == ""){ 
      msg.fire('Proporcione el objetivo', '', 'warning');
      return;
    }
    if (this.est.length == 0){
      msg.fire('Proporcione por lo menos una estrategia', '', 'warning');
      return;
    }
    if (this.ent.length == 0){
      msg.fire('Proporcione por lo menos un entregable', '', 'warning');
      return;
    }
    if (this.fechaestini == ""){
      msg.fire('Proporcione la fecha de inicio de la estrategia', '', 'warning');
      return;
    }
    if (this.fechaestfin == ""){
      msg.fire('Proporcione la fecha de cierre de la estrategia', '', 'warning');
      return;
    }
    if (this.int.length == 0){
      msg.fire('Proporcione por lo menos un integrante de equipo', '', 'warning');
      return;
    }
    if (this.equ.length == 0){
      msg.fire('Proporcione por lo menos un equipo de soporte', '', 'warning');
      return;
    }
    if (this.mat.length == 0){
      msg.fire('Proporcione por lo menos un material', '', 'warning');
      return;
    }
    if (this.cap.length == 0){
      msg.fire('Proporcione por lo menos un entrenamiento', '', 'warning');
      return;
    }
    if (this.itm.facilitador == ""){ 
      msg.fire('Proporcione el facilitador', '', 'warning');
      return;
    }
    if (this.itm.patrocinador == ""){ 
      msg.fire('Proporcione el patrocinador', '', 'warning');
      return;
    }
    if (this.itm.vpmexico == ""){ 
      msg.fire('Proporcione el VP México', '', 'warning');
      return;
    }
    if (this.fechapat == ""){
      msg.fire('Proporcione la fecha de patrocinador', '', 'warning');
      return;
    }
    if (this.fechavp == ""){
      msg.fire('Proporcione la fecha de VP México', '', 'warning');
      return;
    }
    
    var sqry;
    
    sqry = " call spinsupd_tblcharter_cha (" + 
            this.itm.id_matriz + ",'" +
            this.itm.nombre  + "','" +
            this.itm.numero  + "','" +
            this.itm.objetivo  + "','" +
            this.itm.facilitador  + "','" +
            this.itm.patrocinador  + "','" +
            this.itm.vpmexico  + "','" +
            this.fechaini  + "','" +
            this.fechaestini  + "','" +
            this.fechaestfin  + "','" +
            this.fechapat  + "','" +
            this.fechavp  + "'," +
            this.itm.id + ")";
    
    this.loading =  true;                                
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        if (res.length!=0){
          
          
          for (let i = 0; i < this.ant.length; i++) {
            sqry = " insert into tblantecedente_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.ant[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.est.length; i++) {
            sqry = " insert into tblestrategia_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.est[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.ent.length; i++) {
            sqry = " insert into tblentregable_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.ent[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.lstint.length; i++) {
            sqry = " insert into tblintegrante_cha (id_charter,id_personal) values (" + 
                    res[0][0].id + "," +
                    this.lstint[i].id + ")";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.lstequ.length; i++) {
            sqry = " insert into tblequipo_cha (id_charter,id_equipo) values (" + 
                    res[0][0].id + "," +
                    this.lstequ[i].id + ")";                    
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.mat.length; i++) {
            sqry = " insert into tblmaterial_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.mat[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          for (let i = 0; i < this.cap.length; i++) {
            sqry = " insert into tblentrenamiento_cha (id_charter,nombre) values (" + 
                    res[0][0].id + ",'" +
                    this.cap[i].nombre + "')";
            this.authService.ejecuta1(sqry)
            .then(
              data1  => {                                                          
            },
            error => {
                this.loading =  false;
                msg.fire('Datos incorrectos', '', 'error');
            });            
          }
          

        }
        this.loading =  false;      
        msg.fire({ icon: "success", title: "Registro generado", showConfirmButton: false, timer: 1000 });
        //this.bRegistro= false;          
        this.router.navigate(['/hk']);
        //this.ls_charter();                
    },
    error => {
        this.loading =  false;
        msg.fire('Datos incorrectos', '', 'error');
    });

  }


  nvocha(id,itm){
    

    this.bRegistro = true;

    this.ant = [];
    this.txtant = "";
    this.est = [];
    this.txtest = "";
    this.ent = [];
    this.txtent = "";

    this.lstint = [];
    this.selint = null;
    this.selint = undefined;

    this.lstequ = [];
    this.selequ = null;
    this.selequ = undefined;

    this.mat = [];
    this.txtmat = "";

    this.cap = [];
    this.txtcap = "";   

    this.ls_integrantes();
    this.ls_equipo();
    if (id == 0){
      var data_charter=JSON.parse(localStorage.getItem("data_charter"));
      //console.log("--");
      //console.log(data_charter);
      this.itm.id = 0;
      this.itm.id_matriz = Number(localStorage.getItem("id_charter"));      
      try {
        this.itm.nombre = data_charter.des;  
      } catch (error) {
        this.itm.nombre = "";
      }

      
      this.itm.numero = "";
      this.itm.objetivo = "";
      this.itm.facilitador = "";
      this.itm.patrocinador = "";
      this.itm.vpmexico = "";

      let dt = moment(new Date(), 'DD-MM-YYYY');
      this.fechaini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechaestini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechaestfin = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechapat = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      this.fechavp = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
    }else {      
      this.itm.id = itm.id;
      this.itm.id_matriz = itm.id_matriz;  
      this.itm.nombre = itm.nombre;  
      this.itm.numero = itm.numero;  
      this.itm.objetivo = itm.objetivo;  
      this.itm.facilitador = itm.facilitador;  
      this.itm.patrocinador = itm.patrocinador;  
      this.itm.vpmexico = itm.vpmexico;  
      
      let dt = moment(new Date(itm.fechaini), 'DD-MM-YYYY');
      this.fechaini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechaestini), 'DD-MM-YYYY');
      this.fechaestini = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechaestfin), 'DD-MM-YYYY');
      this.fechaestfin = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechapat), 'DD-MM-YYYY');
      this.fechapat = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')
      dt = moment(new Date(itm.fechavp), 'DD-MM-YYYY');
      this.fechavp = dt.format('YYYY')+ "-" + dt.format('MM') + "-" + dt.format('DD')

      this.loading = true;          
      var sqry;
      sqry = " select" +
             " id, nombre" +
             " from tblantecedente_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      console.log(sqry);
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _ant = [];    
            for(var i = 0; i < res.length;i++){
              _ant.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.ant = _ant;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblestrategia_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _est = [];    
            for(var i = 0; i < res.length;i++){
              _est.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.est = _est;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblentregable_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _ent = [];    
            for(var i = 0; i < res.length;i++){
              _ent.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.ent = _ent;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblmaterial_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _mat = [];    
            for(var i = 0; i < res.length;i++){
              _mat.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.mat = _mat;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblentrenamiento_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _cap = [];    
            for(var i = 0; i < res.length;i++){
              _cap.push({ 
                id:  0, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                edita: false
              });   
            }
          }
          this.cap = _cap;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
      sqry = " select" + 
            " id_personal as id,nombre, titulo" + 
            " from tblintegrante_cha,tblpersonal_cha" + 
            " where tblintegrante_cha.id_personal = tblpersonal_cha.id" + 
            " and id_charter = " + itm.id +
            " order by nombre";
      
            sqry = " select" + 
            " id_personal as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo " + 
            " from tblintegrante_cha,tblpersona_tl" +             
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
            " where tblintegrante_cha.id_personal = tblpersona_tl.id" + 
            " and id_charter = " + itm.id +
            " order by nombre";
      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _int = [];    
            for(var i = 0; i < res.length;i++){
              _int.push({ 
                id:  res[i].id, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                titulo: res[i].titulo,      
                edita: false
              });   
            }
          }
          this.lstint = _int;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

      this.loading = true;          
   
      sqry = " select" + 
             " id_equipo as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo as job" + 
             " from tblequipo_cha,tblpersona_tl" +              
           " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
             " where tblequipo_cha.id_equipo = tblpersona_tl.id" + 
             " and id_charter = " + itm.id +
             " order by nombre";

      this.loading =  true;
      this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _equ = [];    
            for(var i = 0; i < res.length;i++){
              _equ.push({ 
                id:  res[i].id, 
                idx: i+1,
                nombre: res[i].nombre,      
                nombre1: res[i].nombre,      
                job: res[i].job,      
                edita: false
              });   
            }
          }
          this.lstequ = _equ;
      },
      error => {
          this.loading =  false;
          msg.fire('Datos incorrectos', '', 'error');
      });

    }

  }


}
